module.exports = __webpack_public_path__ + "img/file.1f71ca3c.svg";